import {Sprite} from 'pixi.js';
import {Button, consoleLogger, ObjectBuilder} from '@gongxigames/framework/core';
import {KeypadControlsViewMobileLandscape} from '@gongxigames/framework/slot/modules/keypadControls/KeypadControlsViewMobileLandscape';
import {KeypadView, KeypadViewMobilePortrait} from '@gongxigames/framework/slot/modules/keypad';
import {UIElementRepositionData} from '@gongxigames/framework/slot';

export class KeypadControlsViewMobilePortrait extends KeypadControlsViewMobileLandscape {
    public static readonly NAME: symbol = Symbol('KeypadControlsViewMobilePortrait');
    protected turboButtonOn!: Button;
    protected turboButtonOff!: Button;

    public repositionElements(data: UIElementRepositionData[]): void {
        data.forEach(({name, x, y}: UIElementRepositionData) => {
            if (this[name]) {
                if(x) {
                    this[name].x = x;
                }

                if(y) {
                    this[name].y = y;
                }
            }
        });
    }

    protected setupTurboCheckbox(): void {
        this.turboButtonOn = this.mainSprite.getChildByName<Button>('turboButtonOn');
        this.turboButtonOff = this.mainSprite.getChildByName<Button>('turboButtonOff');
        this.setTurboCheckbox(this.turboButtonOn, this.turboButtonOff);
    }

    public setTotalBetWindow(): void {
        const rootName = 'balanceBar_portrait';
        const config = this._objectBuilder.getDisplayObjectConfigByName(rootName);

        if (config) {
            this._totalBetWindow = this._objectBuilder.buildSprite(ObjectBuilder.resources.shared_sprite.balanceBar_portrait);
            this._totalBetWindow.visible = false;
        } else {
            consoleLogger.warn(`No Sprite - '${rootName}'. Please, check resources!`);
        }
    }

    protected initCallbacks(): void {
        super.initCallbacks();

        this._turboCheckbox.changedCallback = this.onTurboCheckboxClicked.bind(this);
    }

    public hideBetPanel(): void {
        this._totalBetPanel.visible = false;
    }

    public showBetPanel(): void {
        this._totalBetPanel.visible = true;
    }

    public disableForeverTurboCheckbox(): void {
        this._turboCheckbox.disable();
        this._turboCheckbox.hide();
        this._disabledTurboCheckbox = true;
    }

    public enableTurboCheckbox(): void {
        if (this._disabledTurboCheckbox) {
            return;
        }

        this._turboCheckbox.enable();
    }

    public disableTurboCheckbox(): void {
        if (this._disabledTurboCheckbox) {
            return;
        }

        this._turboCheckbox.disable();
    }

    public updateTurboCheckbox(isOn: boolean): void {
        this._turboCheckbox.setValue(isOn);
    }

    protected showTurboCheckbox(): void {
        if (this._disabledTurboCheckbox) {
            return;
        }

        this._turboCheckbox.show();
    }

    protected hideTurboCheckbox(): void {
        if (this._disabledTurboCheckbox) {
            return;
        }

        this._turboCheckbox.hide();
    }

    protected get mainSprite(): Sprite {
        return this._installer.getComponent<KeypadView>(KeypadViewMobilePortrait.NAME).mainSprite;
    }

    public getViewDependencies(): (symbol|string)[] {
        return [...super.getViewDependencies(), KeypadViewMobilePortrait.NAME];
    }
}
